import React from 'react'
import { Modal, Button, Form, Select, Input, DatePicker, theme } from 'antd'
import { PlusOutlined, CloseOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Option } = Select

const AddEventModal = ({
  isModalVisible,
  handleCancel,
  handleAdd,
  form,
  theatreRooms,
  eventTypes,
  eventCategories
}) => {
  const { token } = theme.useToken()

  return (
    <Modal
      title='Add Theatre Room Event'
      visible={isModalVisible}
      onCancel={handleCancel}
      footer={[
        <Button
          key='cancel'
          onClick={handleCancel}
          icon={<CloseOutlined style={{ color: token.colorError }} />}
          style={{
            background: hexToRGBA(token.colorError, 0.1),
            borderColor: token.colorError,
            color: token.colorError
          }}
        >
          Cancel
        </Button>,
        <Button
          key='submit'
          onClick={handleAdd}
          icon={<PlusOutlined style={{ color: token.colorSuccess }} />}
          style={{
            background: hexToRGBA(token.colorSuccess, 0.1),
            borderColor: token.colorSuccess,
            color: token.colorSuccess,
            fontWeight: 'bold'
          }}
        >
          Add Event
        </Button>
      ]}
      width={700}
    >
      <Form form={form} layout='vertical'>
        <Form.Item
          name='theatreRoom'
          label='Theatre Room'
          rules={[{ required: true, message: 'Please select a theatre room' }]}
        >
          <Select placeholder='Select theatre room'>
            {theatreRooms.map((room) => (
              <Option key={room} value={room}>
                {room}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='eventType'
          label='Event Type'
          rules={[{ required: true, message: 'Please select event type' }]}
        >
          <Select placeholder='Select event type'>
            {eventTypes.map((type) => (
              <Option key={type} value={type}>
                {type}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='eventCategory'
          label='Event Category'
          rules={[{ required: true, message: 'Please select event category' }]}
        >
          <Select placeholder='Select category'>
            {eventCategories.map((category) => (
              <Option key={category} value={category}>
                {category}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='eventDetails'
          label='Event Details'
          rules={[{ required: true, message: 'Please enter event details' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name='eventStartDate'
          label='Start Date/Time'
          rules={[{ required: true, message: 'Please specify start date and time' }]}
        >
          <DatePicker showTime format='YYYY-MM-DD HH:mm' style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item name='eventEndDate' label='End Date/Time (if known)'>
          <DatePicker showTime format='YYYY-MM-DD HH:mm' style={{ width: '100%' }} />
        </Form.Item>

        <Form.Item
          name='responsibleStaff'
          label='Responsible Staff'
          rules={[{ required: true, message: 'Please specify responsible staff' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item name='isPatientEvent' label='Is this a patient event?' valuePropName='checked'>
          <Select>
            <Option value={true}>Yes</Option>
            <Option value={false}>No</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name='patientId'
          label='Patient'
          rules={[{ required: form.getFieldValue('isPatientEvent'), message: 'Please select a patient' }]}
        >
          <Select placeholder='Select patient' disabled={!form.getFieldValue('isPatientEvent')}>
            <Option value='PT-1542'>Kevin Thompson (PT-1542)</Option>
            <Option value='PT-1563'>Laura Martinez (PT-1563)</Option>
            <Option value='PT-1567'>Barbara Wilson (PT-1567)</Option>
            {/* More options would be populated from patients database */}
          </Select>
        </Form.Item>

        <Form.Item name='status' label='Status' rules={[{ required: true, message: 'Please select status' }]}>
          <Select placeholder='Select status'>
            <Option value='Scheduled'>Scheduled</Option>
            <Option value='In Progress'>In Progress</Option>
            <Option value='Completed'>Completed</Option>
            <Option value='Delayed'>Delayed</Option>
            <Option value='Cancelled'>Cancelled</Option>
          </Select>
        </Form.Item>

        <Form.Item name='notes' label='Notes'>
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default AddEventModal
